import { useDeviceTypes } from "halifax";
import clsx from "clsx";
import React from "react";
import {
  AdsCarousel as AdsCarouselComponent,
  MediaTrackingProvider,
} from "@capone/portal";
import {
  AdsCarousel as CorpAdsCarouselComponent,
  MediaTrackingProvider as CorpMediaTrackingProvider,
} from "@capone-corporate/portal";
import { Tenant } from "redmond";
import "./styles.scss";

export const AdsCarousel = () => {
  const { matchesMobile } = useDeviceTypes();

  return (
    <div
      className={clsx("hts-media-ads-carousel-wrapper", {
        mobile: matchesMobile,
      })}
    >
      <MediaTrackingProvider>
        <AdsCarouselComponent />
      </MediaTrackingProvider>
    </div>
  );
};

const CorpAdsCarousel = () => {
  const { matchesMobile } = useDeviceTypes();

  return (
    <div
      className={clsx("hts-media-ads-carousel-wrapper", {
        mobile: matchesMobile,
      })}
    >
      <CorpMediaTrackingProvider>
        <CorpAdsCarouselComponent />
      </CorpMediaTrackingProvider>
    </div>
  );
};

export const getAdsCarouselByTenant = (tenant: Tenant) => {
  switch (tenant) {
    case "capone":
      return <AdsCarousel />;
    case "brex":
    case "capone-corporate":
      return <CorpAdsCarousel />;
    default:
      return <AdsCarousel />;
  }
};
